import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Login from './components/auth/Login';
import SchoolRegistration from './components/auth/SchoolRegistration';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/layout/Layout';

// Pages
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import StudentDetail from './pages/StudentDetail';
import Teachers from './pages/Teachers';
import Fees from './pages/Fees';
import Registrations from './pages/Registrations';
import Admissions from './pages/Admissions';
import ClassManagement from './pages/ClassManagement';
import Settings from './pages/Settings';
import NotificationManagement from './pages/NotificationManagement';
import HolidayCalendar from './pages/HolidayCalendar';
import Timetable from './pages/Timetable';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<SchoolRegistration />} />

          {/* Protected routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="registrations" element={<Registrations />} />
            <Route path="admissions" element={<Admissions />} />
            <Route path="students/:id" element={<StudentDetail />} />
            <Route path="students/*" element={<Students />} />
            <Route path="teachers/*" element={<Teachers />} />
            <Route path="fees/*" element={<Fees />} />
            <Route path="notifications/*" element={<NotificationManagement />} />
            <Route path="holiday-calendar/*" element={<HolidayCalendar />} />
            <Route path="timetable/*" element={<Timetable />} />
            <Route path="class-management" element={<ClassManagement />} />
            <Route path="settings/*" element={<Settings />} />
          </Route>

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        {/* Toast notifications */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          toastClassName="bg-[#211c15] border border-[#3a3122]"
        />
      </div>
    </Router>
  );
};

export default App;